/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type UpdateLocationDto = {
  /**
   * Location name
   */
  name?: string;
  /**
   * Location type
   */
  type?: UpdateLocationDto.type;
  /**
   * Location address
   */
  address?: string;
  /**
   * Location status
   */
  status?: UpdateLocationDto.status;
};
export namespace UpdateLocationDto {
  /**
   * Location type
   */
  export enum type {
    WAREHOUSE = 'WAREHOUSE',
    BRANCH = 'BRANCH',
  }
  /**
   * Location status
   */
  export enum status {
    ACTIVE = 'ACTIVE',
    INACTIVE = 'INACTIVE',
  }
}
